module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.isShow) ? _c('div', {
    staticClass: "product-card-container product-card-container_pdgbottom20"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    attrs: {
      "id": "mc-container"
    }
  }, [_vm._t("default")], 2), _vm._v(" "), _vm._m(1)]) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "checked-statement"
  }, [_c('div', {
    staticClass: "checked-circle"
  }), _vm._v(" "), _c('h2', {
    staticClass: "checked-statement__statement"
  }, [_vm._v("Отзывы")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "id": "mc-link",
      "href": "https://cackle.me"
    }
  }, [_vm._v("Комментарии для сайта "), _c('b', {
    staticStyle: {
      "color": "#4FA3DA"
    }
  }, [_vm._v("Cackl")]), _c('b', {
    staticStyle: {
      "color": "#F65077"
    }
  }, [_vm._v("e")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24ad2c51"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./assets/vue/components/productcomments/productcomments.vue
// module id = 579
// module chunks = 0